module.exports = __webpack_public_path__ + "fonts/brandon_med-webfont-webfont.e10f30df6fb8d5389f08ff1bd3674535.woff2";